// Pure halves of the property-edit save path, shared by the row-edit modal
// and the Property Review walkthrough.

const has = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key)

// Whitelists the editable fields accepted by the territory override PATCH.
export const buildTerritoryPatchBody = (payload = {}) => {
  const body = {}
  if (has(payload, 'mowingEnabled')) body.mowingEnabled = !!payload.mowingEnabled
  if (has(payload, 'prescribedManHours')) {
    // null clears the prescription; a positive number sets it.
    body.prescribedManHours = payload.prescribedManHours
  }
  if (has(payload, 'lockedRouteId')) {
    body.lockedRouteId = payload.lockedRouteId
    body.lockedCrewId = payload.lockedCrewId || null
  }
  if (has(payload, 'preferredDays')) body.preferredDays = payload.preferredDays
  if (has(payload, 'requiredDays')) body.requiredDays = payload.requiredDays
  // Solver access window; null clears a bound. The PATCH endpoint handles
  // these (hasAccessWindowUpdate in territoryProperties.controller.js).
  if (has(payload, 'accessEarliestMin')) body.accessEarliestMin = payload.accessEarliestMin
  if (has(payload, 'accessLatestMin')) body.accessLatestMin = payload.accessLatestMin
  if (has(payload, 'mtcFrequency')) body.mtcFrequency = payload.mtcFrequency
  if (has(payload, 'irrigationCheckFrequency')) body.irrigationCheckFrequency = payload.irrigationCheckFrequency
  if (has(payload, 'herbicideApplicationFrequency')) body.herbicideApplicationFrequency = payload.herbicideApplicationFrequency
  if (has(payload, 'noIrrigation')) body.noIrrigation = !!payload.noIrrigation
  // Assigned irrigation tech (Crew _id or null). null clears the assignment.
  if (has(payload, 'irrigationTechId')) body.irrigationTechId = payload.irrigationTechId
  if (has(payload, 'setupChecklist')) {
    // { geofenceSet, propertyLinesVerified, takeoffComplete } confirm flags.
    // Server stamps confirmedAt/confirmedBy + writes the Jobsite. takeoffComplete
    // drives the green ✓ (complete) vs amber Site Data state.
    body.setupChecklist = payload.setupChecklist
  }
  return body
}

// Optimistically reflect saved fields without a full refetch round-trip.
// setupChecklist is nested on the Jobsite server-side; the Site Data cell
// reads p.siteTakeoff.complete + p.setupChecklist, so mirror the confirmed
// flags onto both rather than spreading the raw PATCH body.
export const applySavedFieldsToProperty = (p, body) => {
  const next = { ...p }
  if (has(body, 'mowingEnabled')) next.mowingEnabled = body.mowingEnabled
  if (has(body, 'prescribedManHours')) next.prescribedManHours = body.prescribedManHours
  if (has(body, 'lockedRouteId')) {
    next.lockedRouteId = body.lockedRouteId
    next.lockedCrewId = body.lockedCrewId
  }
  if (has(body, 'preferredDays')) next.preferredDays = body.preferredDays
  if (has(body, 'requiredDays')) next.requiredDays = body.requiredDays
  if (has(body, 'accessEarliestMin')) next.accessEarliestMin = body.accessEarliestMin
  if (has(body, 'accessLatestMin')) next.accessLatestMin = body.accessLatestMin
  if (has(body, 'mtcFrequency')) next.mtcFrequency = body.mtcFrequency
  if (has(body, 'irrigationCheckFrequency')) next.irrigationCheckFrequency = body.irrigationCheckFrequency
  if (has(body, 'herbicideApplicationFrequency')) next.herbicideApplicationFrequency = body.herbicideApplicationFrequency
  if (has(body, 'noIrrigation')) next.noIrrigation = body.noIrrigation
  if (has(body, 'irrigationTechId')) next.irrigationTechId = body.irrigationTechId
  if (body.setupChecklist) {
    const sc = body.setupChecklist
    next.setupChecklist = {
      geofenceSet: { ...(p.setupChecklist?.geofenceSet || {}), confirmed: !!sc.geofenceSet?.confirmed },
      propertyLinesVerified: { ...(p.setupChecklist?.propertyLinesVerified || {}), confirmed: !!sc.propertyLinesVerified?.confirmed },
      takeoffComplete: { ...(p.setupChecklist?.takeoffComplete || {}), confirmed: !!sc.takeoffComplete?.confirmed, notes: sc.takeoffComplete?.notes || null }
    }
    next.siteTakeoff = {
      ...(p.siteTakeoff || { totalSF: 0, areaCount: 0 }),
      complete: !!sc.takeoffComplete?.confirmed,
      notes: sc.takeoffComplete?.notes || null
    }
  }
  return next
}
